import axios from "axios";
import Consts from "./consts";

type AnyVoidFunc = (arg: any) => {};

interface MaxiosLeg {
    url: string,
    data?: any,
    noApi?: boolean,
    noErrorSet?: boolean,
    success: AnyVoidFunc,
    setError?: AnyVoidFunc,
}


function maxiGetObj({url, success, noApi, noErrorSet, setError}: MaxiosLeg): void {

    axios.get((!noApi ? Consts.API_PREFIX : "") + url, {
        headers: {
            'Content-Type': 'application/json',
        }
    })
        .then(response => {

            if (response.data.status === "error") {
                throw Error(response.data.message)
            } else {
                success(response.data)
            }
        })
        .catch((error) => {
            console.log("error", error);
            if (!noErrorSet && setError !== undefined) {
                setError(error)
            }
        });
}

function maxiPostObj({url, data, success, noApi, noErrorSet, setError}: MaxiosLeg): void {
    axios.post((!noApi ? Consts.API_PREFIX : "") + url, data, {
        headers: {
            'Content-Type': 'application/json',
        }
    })
        .then(response => {

            if (response.data.status === "error") {
                throw Error(response.data.message)
            } else {
                success(response.data)
            }
        })
        .catch((error) => {
            console.log("error", error);
            if (!noErrorSet && setError !== undefined) {
                setError(error)
            }
        });
}


export {maxiGetObj, maxiPostObj}
